const BlockScenarioDefault = {
    object_id : null,
    name : 'Scenario',
    x : 0,
    y : 0,
    width : 5,
    height : 2,
    type : { name : 'scenario'},
    data : { basic : 0 },
    children : [
        {text: "", index : null, object_id : null, parent_block_id : null}
    ],
}

const BlockScenarioServerDefault = {
    type : 'scenario',
    basic : 0
}

export {BlockScenarioDefault, BlockScenarioServerDefault}